import React, { Component, Fragment } from 'react'
import ButtonsPlaceholder from '../AddCart/ButtonsPlaceholder'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import MediaQuery from 'react-responsive'
import { Button } from 'loyal-react'
import { connect } from 'react-redux'
import { changeVisualizationContext } from 'App/MainMenu/OnlyCash/actions'

class ChangeContext extends Component {
  constructor (props) {
    super()
    this.state = {
      onlyCash: props.onlyCash
    }
  }

  changeContext = () => {
    this.props.changeContextRequest(!this.props.onlyCash)
    this.setState({ onlyCash: !this.props.onlyCash })
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }

  render () {
    return (
      <Fragment>
        <ReactPlaceholder
          ready={!this.props.isLoading}
          customPlaceholder={<ButtonsPlaceholder />}
        >
          <div className='card-buttons row px-2 border-color-ui-3'>
            <div className='card-button col-12 row'>
              <MediaQuery minDeviceWidth={767}>
                <Button
                  id={'changeContext'}
                  name={'changeContext'}
                  className='d-md-block d-none btn btn-featured btn-icon py-2'
                  text={
                    this.props.onlyCash
                      ? 'Comprar com Reales'
                      : 'Comprar com Cartão'
                  }
                  onClick={
                    () => this.changeContext()
                  }
                  iconName='icon_cart'
                  disabled={this.props.cart && this.props.cart.isLoading ? 'disabled' : ''}
                  loading={this.props.cart && this.props.cart.isLoading}
                />

              </MediaQuery>
              <MediaQuery maxDeviceWidth={768}>
                <Button
                  id={'changeContext'}
                  name={'changeContext'}
                  className='d-md-none d-block btn btn-featured btn-icon py-2'
                  text={
                    this.props.onlyCash
                      ? 'Comprar com Reales'
                      : 'Comprar com Cartão'
                  }
                  onClick={
                    () => this.changeContext()
                  }
                  iconName='icon_cart'
                  disabled={this.props.cart && this.props.cart.isLoading ? 'disabled' : ''}
                  loading={this.props.cart && this.props.cart.isLoading}
                />

              </MediaQuery>
            </div>
          </div>
          <MediaQuery maxDeviceWidth={420}>
            <div className='float-button bg-white px-1 py-2 row mx-0 d-flex align-items-center'>
              <div className='col-6 px-0'>
                <Button
                  id={'changeContext'}
                  name={'changeContext'}
                  className='btn btn-sm btn-featured nowrap'
                  text={
                    this.props.onlyCash
                      ? 'Comprar com Reales'
                      : 'Comprar com Cartão'
                  }
                  onClick={
                    () => this.changeContext()
                  }
                  disabled={this.props.cart && this.props.cart.isLoading ? 'disabled' : ''}
                  loading={this.props.cart && this.props.cart.isLoading}
                />
              </div>
            </div>
          </MediaQuery>
        </ReactPlaceholder>
      </Fragment>
    )
  }
}
ChangeContext.propTypes = {
  isLoading: PropTypes.bool,
  cart: PropTypes.object,
  onlyCash: PropTypes.bool,
  changeContextRequest: PropTypes.func
}

const mapStateToProps = ({ onlyCash }) => ({
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  changeContextRequest: cash => dispatch(changeVisualizationContext(cash))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeContext)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/ChangeContext/ChangeContext.js